import { render, staticRenderFns } from "./DevSetting.vue?vue&type=template&id=894e0804"
import script from "./DevSetting.vue?vue&type=script&lang=js"
export * from "./DevSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports